import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import FilterInput from "../../components/filterDropdown/FilterInput";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import { BannerNotificationType } from "../../components/SimpleBanner";

export function LabSamplesViewModel(logout) {
  const defaultFilters = {
    laboratory: { value: -1, label: "Select Laboratories" },
    startDate: new Date(),
    endDate: new Date(),
  };

  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [samples, setSamples] = useState({ data: [], total: 0 });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [showFilters, setShowFilters] = useState(false);

  const [labsForDropdown, setLabsForDropdown] = useState([
    { value: -1, label: "Select Laboratories" },
  ]);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getSamples = async function (search, page, filterArg) {
    setLoading(true);
    const payload = {
      page: page,
      filters: { ...filterArg, search: search },
    };

    let callResult = await makePostApiCall(`labSamples`, payload);
    setLoading(false);
    if (callResult.success) {
      setSamples(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showErrorModal("Could not load lab samples");
      }
    }
  };

  const resetFilters = () => {
    setFilters(defaultFilters);
    setShowFilters(false);
    getSamples(null, 1, defaultFilters);
  };

  const getLabsForDropdown = async function () {
    let callResult = await makePostApiCall(`laboratoriesForDropdown`);
    if (callResult.success) {
      setLabsForDropdown([
        { value: -1, label: "Select Laboratories" },
        ...callResult.data,
      ]);
    } else {
      if (callResult.errorStatus === 401) logout();
    }
  };

  const filterComponents = [
    <DateRangeFilter
      key="date"
      onChange={(startDate, endDate) =>
        setFilters({
          ...filters,
          startDate: startDate,
          endDate: endDate,
        })
      }
      endDate={filters.endDate}
      startDate={filters.startDate}
      setShowDates={() => {}}
      showDates={false}
      applyChanges={() => {}}
      maxDate={new Date()}
      rangeSummary={""}
    />,
    <FilterSingleSelectDropdown
      key="lab"
      header="Laboratory"
      onChange={(value) =>
        setFilters({
          ...filters,
          laboratory: value,
        })
      }
      options={labsForDropdown}
      resetFilter={() =>
        setFilters({
          ...filters,
          laboratory: { value: -1, label: "Select Laboratories" },
        })
      }
      valueName="laboratory"
      value={filters.laboratory}
    />,
    <FilterInput
      key="search"
      header="Search"
      onChange={(value) => setFilters({ ...filters, search: value })}
      resetFilter={() => setFilters({ ...filters, search: null })}
      valueName="search"
      value={filters.search}
    />,
  ];

  return {
    emptyModal,
    loading,
    setEmptyModelOpen,
    setShowSimpleNotification,
    showSimpleNotification,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    samples,
    getSamples,
    getLabsForDropdown,
    setFilters,
  };
}

export default LabSamplesViewModel;
